module.exports = __webpack_public_path__ + "/build/web/images/hero-warranty@2x.b16e268c492b6c756a5016a6de703847.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-warranty@2x.jpg
// module id = 155
// module chunks = 13